<template>
    <div class="cardPasswordSecurity">

        <div class="passwordTitleSatisfaction">
          <h2>Segurança da senha</h2> -
            <span v-if="acceptable" class="passwordSatisfaction passwordSatisfaction--success">
              Satisfatória
            </span>
            <span v-else class="passwordSatisfaction passwordSatisfaction--error">
              Insatisfatória
            </span>
        </div>

        <div class="strengthBarContainer">
          <div
            class="strengthBar"
            :style="{ width: strengthBarWith, backgroundColor: strengthBarColor }"
          ></div>
        </div>
        <div class="passwordRules">
            <div class="rule">
                <img :src="ruleImage('length')" alt="" id="img_length_min_rule">
                <span>Ao menos 8 caracteres</span>
            </div>

            <div class="rule">
                <img :src="ruleImage('numbers')" alt="" id="number_rule">
                <span>Ao menos 1 número</span>
            </div>

            <div class="rule">
                <img :src="ruleImage('specialChars')" alt="" id="special_char_rule">
                <span>Ao menos 1 caractere especial</span>
            </div>

            <div class="rule">
                <span>Use letras maiúsculas e minúsculas</span>
            </div>
        </div>
    </div>
</template>
<script setup>

import { computed } from 'vue';

const props = defineProps({
  strength: Number,
  acceptable: Boolean,
  violations: Object,
});

const ruleImage = (ruleName) => {
  return props.violations[ruleName] ? '/images/check-different-passwords.svg' : '/images/check-same-passwords.svg';
};

const strengthBarWith = computed(() => {
  const strength = props.strength || 0;
  return `${strength / 7 * 100}%`;
});

const strengthBarColor = computed(() => {
  let strength = Number(props.strength || 0);
  if (strength > 7) {
    strength = 7;
  }
  return {
    0: '#C5D1E2',
    1: '#ff0000',
    2: '#ff4500',
    3: '#ffbf00',
    4: '#ccdd43',
    5: '#6bdd43',
    6: '#1ecb1b',
    7: '#038b00',
  }[strength];
});

</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .cardPasswordSecurity{
        background-color: white;
        height: 205px;
        width: 90%;
        display: flex;
        flex-direction: column;
        align-self: center;
       padding: 16px;
        gap: 24px;
        border-radius: 8px; justify-content: center;
    }

    .passwordTitleSatisfaction{
      display: flex;
      justify-content: start;
      align-items: center;
      gap: 5px;
    }

    .passwordSatisfaction{
      font-size: 12px;
    }
    .passwordSatisfaction--success {
      color: #1ecb1b;
    }
    .passwordSatisfaction--error {
      color: #ff0000;
    }

    .cardPasswordSecurity h2{
        font-size: 16px;
        font-weight: 500;
        color: $color-card-dark;
    }

    .strengthBarContainer{
        width: 100%;
        height: 6px;
        background-color: #C5D1E2;
        border-radius: 8px;
        align-self: center;
    }

    .strengthBar{
        width: 0;
        height: 6px;
        background-color: #C5D1E2;
        transition: all 0.33s ease-in-out;
    }

    .passwordRules{
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .rule{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 7px;
        font-size: 14px;
        color: #435254;
    }
</style>
